
    import Vue from "vue";

    const END_POINT = "/grade";

    const getGrade = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllGrades = data => Vue.axios.get(END_POINT, {params: data});

    const createGrade = grade => Vue.axios.post(END_POINT,  grade );

    const createAllGrades = Grades => Vue.axios.post(END_POINT + "/all",  Grades );

    const updateGrade = grade => Vue.axios.put(END_POINT  + "/" + grade.id,  grade );

    const deleteGrade = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getGrade,
      getAllGrades,
      createGrade,
      createAllGrades,
      updateGrade,
      deleteGrade
    };
    